import { render, staticRenderFns } from "./WrapperCampaignList.vue?vue&type=template&id=2f8db73c&scoped=true&"
import script from "./WrapperCampaignList.vue?vue&type=script&lang=js&"
export * from "./WrapperCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./WrapperCampaignList.vue?vue&type=style&index=0&id=2f8db73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8db73c",
  null
  
)

export default component.exports